export default {
  custom_additive: {
    placeholder: 'Adaugă opțiune personalizată',
  },
  buttons: {
    add: 'Adaugă',
  },
};
